import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import FeaturedSection from "./components/FeaturedSection";
import InsightSections from "./components/InsightSections";
import FaqSection from "./components/FaqSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <FeaturedSection />
        <InsightSections />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}